module.exports = __webpack_public_path__ + "media/images/device-f5df9ec28d824a445d2f2dfb602e2518.png";